import { createContext, useContext } from "react";
const fragmentContext = createContext(null);
function useFromFragmentContext(key) {
  return useFragmentContext().inject(key);
}
function useFragmentContext() {
  return useContext(fragmentContext);
}
function useFragmentRouter() {
  return useFromFragmentContext("router");
}
export {
  useFragmentRouter as a,
  fragmentContext as f,
  useFragmentContext as u
};
//# sourceMappingURL=inject.js.map
